import React from "react";
import { Link } from "react-router-dom";

const RecoveryCard = ({ title, text }) => (
  <div className="recovery-card">
    <div className="fs-20 fw-bold">{title}</div>
    <p className="fs-18">{text}</p>
  </div>
);

const RevenueRecovery = () => {
  return (
    <section className="recovery-area pt-100 pb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9 text-center section-content">
            <span className="fs-15 fw-semibold sub-titles">Pour dirigeants, DAF, achats et contrôle de gestion</span>
            <h1 className="fs-50 mt-3 fw-bold">Une méthode d'audit conçue pour identifier, prouver et récupérer les marges perdues</h1>
            <p className="fs-18">
              WBC intervient sur les données commerciales, comptables et contractuelles pour isoler les écarts réellement exploitables. L'objectif n'est pas de produire un simple rapport, mais un dossier de preuve utilisable en décision interne, en négociation fournisseur et en recouvrement.
            </p>
          </div>
        </div>
        <div className="recovery-grid pt-60">
          <RecoveryCard title="Conditions tarifaires" text="Lecture des grilles, conventions, contrats annuels, remises différées, ristournes, coopérations commerciales et mécanismes d'inflation." />
          <RecoveryCard title="FEC et comptabilité" text="Contrôle des écritures, lettrage, avoirs, doublons, erreurs de TVA, factures manquantes et exhaustivité des flux." />
          <RecoveryCard title="Écarts de prix" text="Rapprochement commandes, réceptions, factures et tarifs attendus pour détecter les trop-payés et variations non justifiées." />
          <RecoveryCard title="Escompte et bon paiement" text="Recalcul des escomptes dus, taux modaux, dates de règlement et ristournes de bon paiement non appliquées." />
          <RecoveryCard title="Baux commerciaux" text="Analyse des loyers, indexations, charges, taxes récupérables et clauses à risque dans les baux commerciaux." />
          <RecoveryCard title="Proposition commerciale" text="Chiffrage selon taille d'entreprise, nombre de fournisseurs, volume documentaire, période auditée et complexité de recouvrement." />
        </div>
        <div className="text-center pt-50">
          <Link to="/contact" className="btn-lg primary-btn fs-18 fw-semibold br-10">Demander un audit initial</Link>
        </div>
      </div>
    </section>
  );
};

export default RevenueRecovery;